module.exports = __webpack_public_path__ + "c794f4b25c70da37f74a3113c325a02b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ball-beach.png
// module id = 2583
// module chunks = 0